// default quest properties based on last published quest, which may not be the same as user compiled quest
// progress has the user compiled quest properties
const updateQuestPropertiesFromProgress = quest => {
  if (quest.progress) {
    return {
      ...quest,
      ...quest.progress.quest
    }
  }

  return quest
}

export const getQuestProgressUpdater = pusherData => qp =>
  qp.user_compiled_quest_id === pusherData.user_compiled_quest?.id
    ? {
      ...qp,
      unread_notifications_count:
        pusherData.user_compiled_quest?.unread_notifications_count,
      awaiting_approval:
        pusherData.new_user_master_course_notification?.type === 'checkin_feedback'
          ? false
          : qp.awaiting_approval,
      current_activity_feedback_status:
        pusherData.new_user_master_course_notification?.type === 'checkin_feedback'
          ? pusherData.new_user_master_course_notification?.metadata.resolution
          : qp.current_activity_feedback_status
    }
    : qp

export { updateQuestPropertiesFromProgress }
